module.exports = __webpack_public_path__ + "static/media/btn_arrow_right_gray.6b04dcd7.svg";